<template>
  <section class="mt-5">
    <h2>お問い合わせ</h2>
    <div class="form-navi my-5">
      <ul class="d-flex">
        <li>入力</li>
        <li class="here">内容確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <p>以下の内容でよろしければ送信するを押してください。</p>
      <div class="form-member my-5">
        <div class="inner">
          <form id="frmConfirm">
            <!-- 動的生成部 -->
            <dl style="margin-bottom: 0; border-bottom: 0">
              <dt>お問い合わせ種類</dt>
              <dd>{{ selContact }}</dd>
              <dt>お問い合わせ内容</dt>
              <dd>{{ contact }}</dd>
              <dt>氏名</dt>
              <dd>{{ name1 + "&nbsp;&nbsp;" + name2 }}</dd>
              <dt>氏名（フリガナ）</dt>
              <dd>{{ nameKana1 + "&nbsp;" + nameKana2 }}</dd>
              <dt>性別</dt>
              <dd>{{ sex }}</dd>
              <dt>年齢</dt>
              <dd>{{ age }}</dd>
              <dt>住所</dt>
              <dd>{{ area }}</dd>
              <dt>当社からの返信方法</dt>
              <dd>{{ reply }}</dd>
              <dt>メールアドレス</dt>
              <dd>{{ txtMail }}</dd>
              <dt>電話番号（携帯可）</dt>
              <dd>{{ txtTel }}</dd>
              <dt>FAX番号</dt>
              <dd>{{ txtFax }}</dd>
              <dt>当社からの連絡可能日</dt>
              <dd>{{ selDays }}</dd>
              <dt>当社からの連絡可能時間</dt>
              <dd>{{ selTimes }}</dd>
              <dt>会員登録有無</dt>
              <dd>{{ isMember }}</dd>
            </dl>
            <dl style="margin-bottom: 0; border-bottom: 0">
              <dt>マネージャー（世話役の方）のご紹介</dt>
              <dd>{{ WantMgr }}</dd>
            </dl>
            <template v-if="chkWantMgr">
              <dl id="ForJoin" style="margin-bottom: 0px; border-bottom: 0px">
                <dt style="width: 100%; float: none; background: #fff">
                  ご希望のマネージャー（「入会について」選択時のみ）
                </dt>
                <dt>年齢</dt>
                <dd>{{ selSpoAge }}</dd>
                <dt>性別</dt>
                <dd>{{ spoSex }}</dd>
                <dt>居住地域</dt>
                <dd>{{ spoArea }}</dd>
              </dl>
            </template>
            <dl>
              <dt>その他ご要望</dt>
              <dd>{{ txtAny }}</dd>
            </dl>
          </form>
          <div class="box-p-20 text-center mt-5">
            <button
              v-on:click="putData"
              id="btnSend"
              type="button"
              class="confirm-01 clear"
            >
              送信する
            </button>
          </div>
          <div class="box-p-20 text-center">
            <router-link
              :to="{ path: '/contact', query: { ref: 'Confirm' } }"
              class="back-01 btn d-inline-block"
              >入力画面に戻る</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import Message from "@/modules/Message";
export default {
  data() {
    return {
      selContact: "",
      contact: "",
      name1: "",
      name2: "",
      nameKana1: "",
      nameKana2: "",
      sex: "",
      age: "",
      area: "",
      reply: "",
      txtMail: "",
      txtTel: "",
      txtFax: "",
      selDays: "",
      selTimes: "",
      isMember: "",
      txtMemberNo: "",
      chkWantMgr: false,
      WantMgr: "",
      selSpoAge: "",
      spoSex: "",
      spoArea: "",
      txtAny: "",
      dicContact: [],
      dicAge: [],
      dicArea: [],
      dicTimes: [],
      dicSpoAge: [],
    };
  },
  mounted() {
    this.getFormItems();
    window.scroll(0, 0);
  },
  methods: {
    getFormItems() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getFormItems",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          // this.dicContact = data.dicContact;
          data.dicContact.forEach((item) => {
            this.dicContact[item.Key] = item.Value;
          });
          data.dicAge.forEach((item) => {
            this.dicAge[item.Key] = item.Value;
          });
          data.dicArea.forEach((item) => {
            this.dicArea[item.Key] = item.Value;
          });
          data.dicTimes.forEach((item) => {
            this.dicTimes[item.Key] = item.Value;
          });
        })
        .then(() => {
          this.getData();
        });
    },
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getData",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.selContact = data.SelContact;
          this.contact = data.Contact;
          this.name1 = data.Name1;
          this.name2 = data.Name2;
          this.nameKana1 = data.NameKana1;
          this.nameKana2 = data.NameKana2;
          this.sex = data.Sex;
          this.age = data.Age;
          this.area = data.Part1OfAddress;
          this.reply = data.Reply;
          this.txtMail = data.MailAddress;
          this.txtTel = data.TelNo;
          this.txtFax = data.FaxNo;
          this.selDays = data.ContactDay;
          this.selTimes = data.ContactTime;
          this.isMember = data.ContactMemberTxt;
          this.WantMgr = data.SpoWant;
          this.chkWantMgr = this.WantMgr == "希望する" ? true : false;
          this.selSpoAge = data.SpoAge;
          this.spoSex = data.SpoSex;
          this.spoArea = data.SpoArea;
          this.txtAny = data.Demand;
          if (!this.chkData()) {
            Message.error().fire({
              title: "不正なアクセスです。",
              didClose: () => {
                this.$router.push("/contact");
              },
            });
          }
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "setContact",
        [],
        true,
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push("/contact/end");
        });
    },
    chkData() {
      if (this.selContact == "") return false;
      if (this.contact == "") return false;
      if (this.name1 == "") return false;
      if (this.name2 == "") return false;
      if (this.nameKana1 == "") return false;
      if (this.nameKana2 == "") return false;
      if (this.reply == "") return false;
      if (this.txtMail == "") return false;
      if (this.reply == "電話" && this.selContact == "") return false;
      if (this.reply == "Fax" && this.Fax == "") return false;
      if (this.isMember == "") return false;
      if (this.selContact == "") return false;
      if (this.chkWantMgr && this.selSpoAge == "") return false;
      if (this.chkWantMgr && this.selSpoSex == "") return false;
      if (this.chkWantMgr && this.selSpoArea == "") return false;
      return true;
    },
  },
};
</script>
